const map = {
	"./Regatta-Professional-logo.svg": 34354,
	"./account.svg": 52951,
	"./addIcon.svg": 63684,
	"./addYourLogo.png": 94716,
	"./amex.png": 93956,
	"./artwork-approval.png": 25005,
	"./bags.svg": 99143,
	"./beanies.svg": 8725,
	"./bestPrice.png": 42440,
	"./blockquote.png": 59788,
	"./bsif-hi-res.png": 79324,
	"./bsif.png": 83113,
	"./bulkAndCorporate/amazon-new.png": 75991,
	"./bulkAndCorporate/amazon.svg": 30821,
	"./bulkAndCorporate/andron.png": 1646,
	"./bulkAndCorporate/applebridge.png": 85427,
	"./bulkAndCorporate/asda-new.png": 19770,
	"./bulkAndCorporate/asda.svg": 26960,
	"./bulkAndCorporate/bca.png": 67830,
	"./bulkAndCorporate/bottomImage.svg": 32643,
	"./bulkAndCorporate/bulk-and-corporate-header-big.png": 51289,
	"./bulkAndCorporate/bulk-and-corporate-header-small.png": 20014,
	"./bulkAndCorporate/bulk-gallery-img-1.png": 93091,
	"./bulkAndCorporate/bulk-gallery-img-2.png": 7816,
	"./bulkAndCorporate/bulk-gallery-img-3.png": 22033,
	"./bulkAndCorporate/bulk-gallery-img-4.png": 81022,
	"./bulkAndCorporate/bulk-gallery-img-mobile-1.png": 18800,
	"./bulkAndCorporate/bulk-gallery-img-mobile-2.png": 90091,
	"./bulkAndCorporate/bulk-gallery-img-mobile-3.png": 68962,
	"./bulkAndCorporate/bulk-gallery-img-mobile-4.png": 73213,
	"./bulkAndCorporate/bunzl-new.png": 43316,
	"./bulkAndCorporate/capita.png": 86314,
	"./bulkAndCorporate/colleagues.svg": 42449,
	"./bulkAndCorporate/community.svg": 34036,
	"./bulkAndCorporate/constabulary.png": 95705,
	"./bulkAndCorporate/crown.svg": 89178,
	"./bulkAndCorporate/draindoctor.png": 54943,
	"./bulkAndCorporate/enka.png": 49235,
	"./bulkAndCorporate/esh-build.png": 611,
	"./bulkAndCorporate/gift.svg": 80023,
	"./bulkAndCorporate/harrods.png": 63691,
	"./bulkAndCorporate/info1.svg": 39758,
	"./bulkAndCorporate/info2.svg": 68877,
	"./bulkAndCorporate/introImageBig.png": 79465,
	"./bulkAndCorporate/introImageSmall.png": 57758,
	"./bulkAndCorporate/mail-orange.svg": 4083,
	"./bulkAndCorporate/marked.svg": 89989,
	"./bulkAndCorporate/marvel.svg": 55532,
	"./bulkAndCorporate/metropolitanpolice-new.png": 62947,
	"./bulkAndCorporate/mgl-new.png": 75081,
	"./bulkAndCorporate/ministry-of-defence.png": 68996,
	"./bulkAndCorporate/mkm.png": 76497,
	"./bulkAndCorporate/moypark-new.png": 1004,
	"./bulkAndCorporate/muehlhan.png": 55110,
	"./bulkAndCorporate/networks-services.png": 80662,
	"./bulkAndCorporate/new-castle.png": 9845,
	"./bulkAndCorporate/newLogoBulkAndCorporate.png": 10703,
	"./bulkAndCorporate/nhs.png": 27217,
	"./bulkAndCorporate/opportunity.svg": 51684,
	"./bulkAndCorporate/our-tech-foreground-img.svg": 82230,
	"./bulkAndCorporate/our-tech-img-mobile.png": 87164,
	"./bulkAndCorporate/our-tech-img.png": 79943,
	"./bulkAndCorporate/package.svg": 52603,
	"./bulkAndCorporate/partnership-mobile.png": 3953,
	"./bulkAndCorporate/partnership.png": 104,
	"./bulkAndCorporate/popupelement.svg": 11303,
	"./bulkAndCorporate/popupelementcircle.svg": 53323,
	"./bulkAndCorporate/purchase-direct.png": 46225,
	"./bulkAndCorporate/rexel.png": 34794,
	"./bulkAndCorporate/royalvoluntaryservice.png": 59020,
	"./bulkAndCorporate/satisfaction-image-1.png": 51736,
	"./bulkAndCorporate/satisfaction-image-2.png": 63699,
	"./bulkAndCorporate/satisfaction-image-3.png": 31786,
	"./bulkAndCorporate/satisfaction-image-mobile-1.png": 86729,
	"./bulkAndCorporate/satisfaction-image-mobile-2.png": 96018,
	"./bulkAndCorporate/satisfaction-image-mobile-3.png": 93883,
	"./bulkAndCorporate/scottishpower-new.png": 90395,
	"./bulkAndCorporate/sizewell.png": 26581,
	"./bulkAndCorporate/stjohn-new.png": 75105,
	"./bulkAndCorporate/sustainablity-mobile.png": 3931,
	"./bulkAndCorporate/sustainablity.png": 88022,
	"./bulkAndCorporate/talk-to-the-experts-desktop.png": 91557,
	"./bulkAndCorporate/talk-to-the-experts-mobile.png": 8679,
	"./bulkAndCorporate/tesco-new.png": 12243,
	"./bulkAndCorporate/thescottishgovernment-new.png": 11014,
	"./bulkAndCorporate/uk-power-network.png": 64999,
	"./bulkAndCorporate/volunteering.svg": 44111,
	"./bulkAndCorporate/waitrose.png": 65472,
	"./bulkAndCorporate/whisstl.png": 12856,
	"./bulkAndCorporate/why-workwearexpress-mobile.png": 42988,
	"./bulkAndCorporate/why-workwearexpress.png": 59287,
	"./bulkAndCorporate/williams-racing.png": 37381,
	"./bulkAndCorporate/x.svg": 29275,
	"./bunzl-hi-res.png": 79411,
	"./caps.svg": 53953,
	"./card-american-express.png": 60755,
	"./card-mastercard.png": 18242,
	"./card-paypal.png": 28687,
	"./card-visa.png": 78401,
	"./carhartt.jpg": 3830,
	"./carousel-img-1.png": 54707,
	"./carousel-img-10.png": 47419,
	"./carousel-img-11.png": 32594,
	"./carousel-img-12.png": 63561,
	"./carousel-img-2.png": 8952,
	"./carousel-img-3.png": 46433,
	"./carousel-img-4.png": 28718,
	"./carousel-img-5.png": 57943,
	"./carousel-img-6.png": 99836,
	"./carousel-img-7.png": 82725,
	"./carousel-img-8.png": 88194,
	"./carousel-img-9.png": 9323,
	"./check-mark-green.svg": 79506,
	"./check.png": 17945,
	"./checkoutImg.png": 95584,
	"./clearance.png": 87587,
	"./cms/about-header.jpg": 30456,
	"./cms/about-us-1.jpg": 74449,
	"./cms/about-us-2.jpg": 16678,
	"./cms/about-us-3.jpg": 97731,
	"./cms/about-us-4.jpg": 66576,
	"./cms/about-us-5.jpg": 10029,
	"./cms/about-us-6.jpg": 61538,
	"./cms/about-us-7.jpg": 97887,
	"./cms/about-us-8.jpg": 53788,
	"./cms/about-us-header.jpg": 83253,
	"./cms/artwork-approval.jpg": 86871,
	"./cms/artwork-embroidery.jpg": 26546,
	"./cms/artwork-fonts.jpg": 19450,
	"./cms/artwork-pantone.jpg": 22377,
	"./cms/artwork-pdf.jpg": 78994,
	"./cms/artwork-tif.jpg": 13373,
	"./cms/artwork-vector.jpg": 83551,
	"./cms/certifications.jpg": 45586,
	"./cms/delivery-header.png": 12297,
	"./cms/faq-header.jpg": 70873,
	"./cms/generic-header.png": 62300,
	"./conversation.svg": 6363,
	"./credit-cards.jpg": 19236,
	"./curled-arrow.png": 7740,
	"./cyber-essentials-transparent-hi-res.png": 29862,
	"./cyber-essentials.png": 40442,
	"./delete.svg": 47047,
	"./delivery.png": 369,
	"./digitization.png": 18976,
	"./disability-confident.png": 77344,
	"./dpd-delivery.png": 93252,
	"./dpd.png": 79117,
	"./ecovadis-hi-res.png": 53140,
	"./ecovadis.png": 59601,
	"./embroidery10.svg": 94821,
	"./envelope.svg": 32302,
	"./epsPlaceholder.png": 18332,
	"./error-red.svg": 80166,
	"./fedex-delivery.png": 68506,
	"./footwear.svg": 35383,
	"./free-logo.png": 14287,
	"./free-returns-img1.png": 44946,
	"./free-returns-img2.png": 9481,
	"./guarantee.png": 72763,
	"./hh.svg": 68334,
	"./hi-vis.svg": 49658,
	"./home/deal-01.jpg": 29895,
	"./home/deal-02.jpg": 97048,
	"./home/deal-03.jpg": 58229,
	"./home/deal-mob-01.jpg": 19352,
	"./home/deal-mob-02.jpg": 56807,
	"./home/deal-mob-03.jpg": 970,
	"./home/deal-widget-01.jpg": 3548,
	"./home/deal-widget-02.jpg": 71243,
	"./home/deal-widget-03.jpg": 44782,
	"./home/deal-widget-jan-01.jpg": 28728,
	"./home/deal-widget-jan-02.jpg": 82535,
	"./home/deal-widget-jan-03.jpg": 26698,
	"./home/homepage-bundle-1.jpg": 97994,
	"./home/homepage-bundle-2-updated.jpg": 59531,
	"./home/homepage-bundle-2.jpg": 38485,
	"./home/homepage-bundle-3.jpg": 77304,
	"./hoodies.svg": 84745,
	"./iso.png": 59294,
	"./iso27001-hi-res.png": 95505,
	"./iso45001-hi-res.png": 34957,
	"./isoqar-iso14001.png": 19566,
	"./isoqar-iso45001.png": 2260,
	"./isoqar-iso9001.png": 3970,
	"./isoqar-ukas-iso27001.png": 3981,
	"./isoqar-ukas-joint-logo.png": 53282,
	"./jackets.svg": 33619,
	"./location.png": 91004,
	"./logo-footer-desktop.svg": 29806,
	"./logo-footer-mobile.svg": 91668,
	"./logo-header-desktop-black-version.svg": 23321,
	"./logo-header-desktop-white-version.svg": 78843,
	"./logo-header-desktop.svg": 18952,
	"./logo-header-mobile.svg": 74646,
	"./logo-outline.svg": 63978,
	"./logo-simple.svg": 51230,
	"./lrqa.jpg": 15413,
	"./magic-passwordless-login-email-template-logo.png": 34597,
	"./mastercard.png": 39125,
	"./newEmbroidery.png": 47463,
	"./newPrint.png": 93470,
	"./open-padlock.svg": 20175,
	"./orange-arrow-down.png": 734,
	"./order-accepted.png": 91439,
	"./order-confirmation.png": 30627,
	"./palette.png": 29208,
	"./paypal.png": 69996,
	"./pdf-icon-01.png": 63149,
	"./pending-orange.svg": 88654,
	"./personalised-image.png": 46918,
	"./phone-call.svg": 45611,
	"./placeholder-logo.jpg": 28824,
	"./placeholder.jpg": 82350,
	"./polo-shirts.svg": 46716,
	"./ppe.svg": 72543,
	"./prices1.png": 73654,
	"./print10.svg": 47300,
	"./product.jpg": 52408,
	"./production.png": 40124,
	"./return.png": 31611,
	"./reviews-logo10.png": 97235,
	"./reviews-logo10.svg": 27140,
	"./save_money.png": 46675,
	"./search-x.svg": 31813,
	"./sedex.png": 75754,
	"./select_arrow.png": 11691,
	"./share.svg": 1955,
	"./star.png": 58929,
	"./stickers.svg": 81478,
	"./sustainability/best-workplaces.png": 50595,
	"./sustainability/commitments-desktop-1.jpg": 87792,
	"./sustainability/commitments-desktop-2.jpg": 2143,
	"./sustainability/commitments-mobile-1.jpg": 41108,
	"./sustainability/commitments-mobile-2.jpg": 70819,
	"./sustainability/list-component-image-1.jpg": 93667,
	"./sustainability/list-component-image-2.jpg": 99188,
	"./sustainability/list-component-image-3.jpg": 96561,
	"./sustainability/list-component-image-4.jpg": 7330,
	"./sustainability/list-component-image-5.jpg": 19999,
	"./sustainability/list-component-image-6.jpg": 35664,
	"./sustainability/list-component-image-7.jpg": 36589,
	"./sustainability/place-to-work-desktop-1.jpg": 13259,
	"./sustainability/place-to-work-desktop-2.jpg": 21276,
	"./sustainability/place-to-work-desktop-3.jpg": 42329,
	"./sustainability/place-to-work-desktop-4.jpg": 71434,
	"./sustainability/place-to-work-mobile-1.jpg": 23685,
	"./sustainability/place-to-work-mobile-2.jpg": 1082,
	"./sustainability/place-to-work-mobile-3.jpg": 64919,
	"./sustainability/place-to-work-mobile-4.jpg": 83724,
	"./sustainability/sustainability-ecovadis-logo.png": 19175,
	"./sustainability/sustainability-global-scale-desktop.jpg": 33496,
	"./sustainability/sustainability-global-scale-mobile.jpg": 81924,
	"./sustainability/sustainability-header-desktop.jpg": 38399,
	"./sustainability/sustainability-header-mobile.jpg": 94401,
	"./sweatshirts.svg": 39161,
	"./t-shirts.svg": 24120,
	"./transparent-shirt.png": 2600,
	"./transparent-workwear-logo.png": 6382,
	"./trousers.svg": 16345,
	"./tshirts/customer-opinion-2-mob.jpg": 57690,
	"./tshirts/customer-opinion-2.jpg": 59671,
	"./tshirts/customer-opinion-3.jpg": 72154,
	"./tshirts/price-beat.jpg": 2771,
	"./tshirts/tshirt-calculator.jpg": 18818,
	"./tshirts/tshirt-page-hero.jpg": 44914,
	"./tshirts/tshirt-page1.jpg": 39730,
	"./tshirts/tshirt-page2.jpg": 58685,
	"./tshirts/tshirt-page3.jpg": 49472,
	"./tshirts/tshirt-page4.jpg": 73427,
	"./tshirts/tshirt-page5.jpg": 18166,
	"./tshirts/tshirt-page6.jpg": 67777,
	"./tshirts/tshirt-page7.jpg": 89732,
	"./tshirts/tshirt-page8.jpg": 61591,
	"./tshirts/tshirt-page9.jpg": 90426,
	"./tshirts/workwearfeb-34.jpg": 69912,
	"./usp_24hr.svg": 40725,
	"./usp_delivery.svg": 1441,
	"./usp_free.svg": 59051,
	"./usp_promise.svg": 59768,
	"./usp_promise1.svg": 71145,
	"./usp_reviews.png": 31695,
	"./visa.png": 86786,
	"./workwear/category-grid/aprons.png": 76611,
	"./workwear/category-grid/beanies.png": 36717,
	"./workwear/category-grid/caps.png": 35475,
	"./workwear/category-grid/contrast-t-shirts.png": 37651,
	"./workwear/category-grid/footwear.png": 15525,
	"./workwear/category-grid/hi-vis-2.png": 79717,
	"./workwear/category-grid/hi-vis.png": 99984,
	"./workwear/category-grid/jackets.png": 96699,
	"./workwear/category-grid/polo-shirts-grey.png": 44738,
	"./workwear/category-grid/polo-shirts.png": 77036,
	"./workwear/category-grid/t-shirts-blue.png": 2673,
	"./workwear/category-grid/t-shirts.png": 35590,
	"./workwear/category-grid/trousers.png": 3335,
	"./workwear/category-grid/w.png": 82617,
	"./workwear/fast-delivery.svg": 64434,
	"./workwear/free-logo.svg": 48335,
	"./workwear/guarantee-orange.svg": 36786,
	"./workwear/hi-vis.png": 15684,
	"./workwear/jackets.png": 42727,
	"./workwear/like.svg": 98,
	"./workwear/logo-amazon.svg": 43143,
	"./workwear/logo-asda.png": 2341,
	"./workwear/logo-asda.svg": 20474,
	"./workwear/logo-castrol.svg": 55269,
	"./workwear/logo-st-john-ambulance.svg": 42361,
	"./workwear/logo-tesco.svg": 28167,
	"./workwear/reason-delivery.png": 19995,
	"./workwear/reason-number-one.png": 15555,
	"./workwear/reason-price-match.png": 31600,
	"./workwear/reason-returns.png": 45446,
	"./workwear/t-shirts.png": 17122,
	"./workwear/workwear-deals-hero.png": 39667,
	"./wwe-background-orange.png": 9930,
	"./wwe-logo-left.png": 61168,
	"./wwe-logo-right-transparent.png": 80128,
	"./wwe-logo-right.png": 39301,
	"./wwe-logo-white-text.svg": 19073,
	"./wwe-logo-white.svg": 30283,
	"./wwe-mobile.png": 35967,
	"./wwe-orange-logo.svg": 59600,
	"./wwe.png": 34618
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91542;